/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Company_Overview_Storage_Balance_InfoInputs */

const es_admin_company_overview_storage_balance_info = /** @type {(inputs: Admin_Company_Overview_Storage_Balance_InfoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Espacio total utilizado por los archivos y documentos guardados en la base de conocimiento de tu espacio de trabajo.`)
};

const en_admin_company_overview_storage_balance_info = /** @type {(inputs: Admin_Company_Overview_Storage_Balance_InfoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Total space used by the files and documents stored in your workspace knowledge base.`)
};

/**
* | output |
* | --- |
* | "Total space used by the files and documents stored in your workspace knowledge base." |
*
* @param {Admin_Company_Overview_Storage_Balance_InfoInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const admin_company_overview_storage_balance_info = /** @type {((inputs?: Admin_Company_Overview_Storage_Balance_InfoInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Company_Overview_Storage_Balance_InfoInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_admin_company_overview_storage_balance_info(inputs)
	return en_admin_company_overview_storage_balance_info(inputs)
});
export { admin_company_overview_storage_balance_info as "admin.company_overview.storage_balance_info" }